/**
 * Wire shape of `GET /admin/search?q=` (#3016), served by
 * `new-backend/admin/src/controllers/searchController.ts` — keep in step.
 *
 * A group the caller may not see (or the tenant's store cannot hold —
 * customer accounts are operational-only) is absent from `groups`; a group
 * that is present with no items was searched and matched nothing.
 */
export type SearchGroupKind = 'bookings' | 'customers' | 'objects' | 'products';

export interface SearchHit {
    id: string;
    title: string;
    subtitle: string | null;
}

export interface SearchGroup {
    kind: SearchGroupKind;
    items: SearchHit[];
}

export interface SearchResponse {
    query: string;
    groups: SearchGroup[];
}

/** Same floor the endpoint enforces; shorter input is never sent. */
export const SEARCH_MIN_LENGTH = 2;
